<template>
  <div class="live">
    <div class="live-menu">
      <div class="logo">
        小艺帮直播监考
      </div>
      <div class="content custom-scrollbar">
        <AuditTab></AuditTab>
      </div>
      <div @click="onLogout" class="logout">
        退出
      </div>
    </div>
    <div class="live-container">
      <AuditView></AuditView>
    </div>
  </div>
</template>
<script>
import AuditView from './components/audit-view.vue';
import AuditTab from './components/audit-tab.vue';
export default {
  components: { AuditView, AuditTab },
  data() {
    return {
    }
  },
  async created() {
    // this.initConnect()
  },
  methods: {
    async onLogout() {
      this.$router.replace('/')
    },
    initConnect() {
      const _this = this
      const connectStreamQualtiyUpdated = function (
        testTaskID,
        roomID,
        streamQualitys
      ) {
        _this.onHandleStreamQualtiyUpdated(testTaskID, roomID, streamQualitys)
      }
      window.core.streamQualtiyUpdated.connect(connectStreamQualtiyUpdated)
      this.$once('hook:beforeDestroy', () => {
        // 销毁页面后取消订阅，避免多次订阅
        window.core.streamQualtiyUpdated.disconnect(connectStreamQualtiyUpdated)
      })
    },
    async onHandleStreamQualtiyUpdated(testTaskID, roomID, streamQualitys) {
      console.log(testTaskID, roomID, streamQualitys, 'testTaskID, roomID, streamQualitys')
    },
    fomatFloat(value, n = 1) {
      var f = Math.round(value * Math.pow(10, n)) / Math.pow(10, n)
      var s = f.toString()
      var rs = s.indexOf('.')
      if (rs < 0) {
        s += '.'
      }
      for (var i = s.length - s.indexOf('.'); i <= n; i++) {
        s += '0'
      }
      return s
    },
  },
}
</script>
<style lang="scss" scoped>
.live {
  width: 100%;
  // width: 240px;
  height: 100%;
  // display: flex;
  // justify-content: flex-start;
  color: #fff;
  position: relative;
  padding-left: 240px;
  .live-menu {
    transition: all 0.2s;
    position: absolute;
    top: 0;
    left: 0;
    width: 240px;
    z-index: 10;
    height: 100%;
    background: linear-gradient(312deg, #1c2241 0%, #2e3459 100%);
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    .logo {
      height: 60px;
      line-height: 60px;
      text-align: center;
      background: linear-gradient(135deg, #00a7ff 0%, #0076ff 100%);
      color: #fff;
    }
    .content {
      overflow-y: auto;
      overflow-x: none;
      flex: 1;
      padding: 24px;
      padding: 20px 10px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.85);
    }
    .logout {
      height: 56px;
      line-height: 56px;
      text-align: center;
      border-top: 1px solid #5d6c86;
      cursor: pointer;
    }
  }
  .live-menu.active {
    left: -240px;
  }
  .mt-10 {
    margin-top: 10px;
    word-break: break-all;
  }
  .live-container {
    width: 100%;
    height: 100%;
  }
}
</style>
